export const UNSAVED_CHANGES_CONFIRMATION_TOKEN = Symbol('UNSAVED_CHANGES_CONFIRMATION')
